export default {"src":"/_next/static/media/spendingplan.59462697.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};